import { createAsyncThunk } from '@reduxjs/toolkit';
import VDKEventDocumentAPI from '@infrastructure/vdk-event-document-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const uploadDocumentAsync = createAsyncThunk('vdkEventDocument/upload', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventDocumentAPI.uploadDocument(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllEventAttachmentsAsync = createAsyncThunk('vdkEventDocument/getAllEventAttachments', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventDocumentAPI.getAllEventAttachments(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createEventAttachmentAsync = createAsyncThunk('vdkEventDocument/createEventAttachment', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventDocumentAPI.createEventAttachment(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteEventAttachmentAsync = createAsyncThunk('vdkEventDocument/deleteEventAttachment', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventDocumentAPI.deleteEventAttachment(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getDocumentDownloadUrlAsync = createAsyncThunk('vdkEventDocument/getDocumentDownloadUrl', async (id, { rejectWithValue }) => {
    try {
        const response = await VDKEventDocumentAPI.getDocumentDownloadUrl(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const uploadEventStoryImageAsync = createAsyncThunk('vdkEventDocument/uploadEventStoryImage', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventDocumentAPI.uploadEventStoryImage(request.eventId, request.file);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const uploadThankYouImageAsync = createAsyncThunk('vdkEventDocument/uploadThankYouImage', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventDocumentAPI.uploadThankYouImage(request.eventId, request.file);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
